
import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import FilterSVG from 'component/svgComponents/filter'
import Col from 'component/utils/Col'
import ContentHeader from 'component/utils/ContentHeader'
import SideFilterParams from 'component/priceBanner/priceBannerParams/SideFilterParams'
import TableParams from 'component/priceBanner/priceBannerParams/TableParams'
import Row from 'component/utils/Row'
import NewPagination from 'component/pagination/newPagination'
import SizeSelect, { components } from 'react-select'
import DropdownArrow from 'component/svgComponents/dropdownArrow'
import { colourStyles } from 'utils/selectStyle'
import { PricebannerAddModal } from 'component/priceBanner/priceBannerParams/PricebannerAddModal'
import SuccessModal from 'component/Modal/SuccessModal'
import PricebannerErrorModal from 'component/priceBanner/general/PricebannerErrorModal'
import DynamicsSelector from 'component/priceBanner/general/DynamicsSelector'
import PricebannerWarningModal from 'component/priceBanner/general/PricebannerWarningModal'
import DetailedWarningModal from 'component/Modal/DetailedWarningModal'
import moment from 'moment'

import * as pricebannerParamsActions from 'action/pricebannerParams'

import '../pictograms/pictograms.css'
import './styles.css'
import PricebannerConfirmExitModal from 'component/priceBanner/general/PricebannerConfirmExitModal'
import ViewModal from '../../components/priceBanner/priceBannerParams/ViewModalParams'
import ExclusionModalPriceBanner from 'component/priceBanner/general/ExclusionModalPriceBanner'


const DEFAULT_PAGINATION = {
  hasPagination: true,
  page: 1,
  size: 10,
}

const DEFAULT_INITIAL_VALUES = {
  order: 'dsDynamic',
  orderDirection: "ASC",
  dsCard: 'Todos',
  idBranches: [],
  cdDynamic: null,
}

const DATE_INPUT_FORMATS = ['DD-MM-YYYY', 'YYYY-MM-DD', 'DD/MM/YYYY', moment.ISO_8601]

const normalizeDateToApi = (date) => {
  if (!date) return null

  const parsed = moment(date, DATE_INPUT_FORMATS, true)
  return parsed.isValid() ? parsed.format('YYYY-MM-DD') : null
}

const normalizeAnnualRange = (start, end, isAnnualRepeat) => {
  if (!isAnnualRepeat || !start || !end) {
    return { dtStart: start, dtEnd: end }
  }

  const startMoment = moment(start, 'YYYY-MM-DD', true)
  const endMoment = moment(end, 'YYYY-MM-DD', true)

  if (!startMoment.isValid() || !endMoment.isValid()) {
    return { dtStart: start, dtEnd: end }
  }

  if (endMoment.isBefore(startMoment)) {
    return {
      dtStart: startMoment.format('YYYY-MM-DD'),
      dtEnd: endMoment.add(1, 'year').format('YYYY-MM-DD')
    }
  }

  return {
    dtStart: startMoment.format('YYYY-MM-DD'),
    dtEnd: endMoment.format('YYYY-MM-DD')
  }
}

const EXTRA_SMALL_SCREEN = 768

const PriceBannerParamsContainer = ({
  auth: {
    user: { dsToken },
  },
  translate,
  fetchAll,
  saveParams,
  updateParams,
  deleteParams,
  list,
  metadata,
  auth,
}) => {
  const displayList = (list || []).map(item => {
    const uniqueBranches = (item.branches || []).filter((branch, index, self) =>
      self.findIndex(b => b.idBranch === branch.idBranch) === index
    );
    const uniqueBranchNamesGrouped = (item.branchNamesGrouped || []).filter((name, index, self) =>
      self.indexOf(name) === index
    );

    const mappedItem = {
      ...item,
      branches: uniqueBranches,
      branchNamesGrouped: uniqueBranchNamesGrouped,
    };
    return mappedItem;
  });

  const [openAddModal,setOpenAddModal] = useState(false)
  const [openSuccessModal, setOpenSuccessModal] = useState(false)
  const [actionMode, setActionMode] = useState(false)
  const [order,setOrder] = useState({order: 'dsDynamic', orderDirection: 'ASC'})
  const [lastTriedPayload, setLastTriedPayload] = useState(null)
  const [openWarningModal, setOpenWarningModal] = useState(false)
  const [showConfirmExitModal, setShowConfirmExitModal] = useState(false)
  const [emptyFilter, setEmptyFilter] = useState(true)
  const [openViewModel,setOpenViewModel] = useState({show: false, selected: null})
  const [openEditModal, setOpenEditModal] = useState({ show: false, selected: null });
  const [openDeleteModal, setOpenDeleteModal] = useState({show: false, selected: null})
  const [openErrorModal, setOpenErrorModal] = useState(false)
  const [failedOperation, setFailedOperation] = useState(null)
  const [failedDeleteData, setFailedDeleteData] = useState(null)
  const [optionSize, setOptionSize] = useState(10)
  const [cdDynamicList, setCdDynamicList] = useState([])
  const [selectedItemsData, setSelectedItemsData] = useState([])
  const [filters, setFilters] = useState()
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION)
  const [sideFilterElement, setSideFilterElement] = useState(null)
  const [sideFilterVisible, setSideFilterVisible] = useState(false)
  const [sideFilterWidth, setSideFilterWidth] = useState(0)
  const [topMargin, setTopMargin] = useState(0)
  const [errorDetails,setErrorDetails] = useState(() => translate('price.banner.error.session.expired'))
  const [successMessage, setSuccessMessage] = useState('');
  const [showDynamicWarningModal, setShowDynamicWarningModal] = useState(false);
  const [dynamicWarningMessage, setDynamicWarningMessage] = useState('');
  const [dynamicWarningType, setDynamicWarningType] = useState('warning');
  const [dynamicWarningScrollableList, setDynamicWarningScrollableList] = useState(null);

  const headerRef = useRef(null)
  const filterRef = useRef(null)
  const tableRef = useRef(null)
  const forceCloseRef = useRef(false);


  // Did mount
  useEffect(() => {
    const param = {
      ...DEFAULT_INITIAL_VALUES,
      ...DEFAULT_PAGINATION
    }

    setFilters(DEFAULT_INITIAL_VALUES)
    fetchAll(dsToken, param)
  }, [])

  // When filters change
  useEffect(() => {
    if(!filters) return
    const param = {
      ...DEFAULT_PAGINATION,
      ...filters,
      ...order,
      size: optionSize,
      idBranches: filters.idBranchesCodes ?? filters.idBranches ?? [],

    }

    delete param.idBranchesCodes;

    fetchAll(dsToken, param)
    
  }, [filters])

  // When pagination changes
  useEffect(() => {
    if(!filters) return
    const param = {
      ...filters,
      ...pagination,
      ...order,
      page: pagination.page,
      idBranches: filters.idBranchesCodes ?? filters.idBranches ?? [],
  };
    
    fetchAll(dsToken, param)
  }, [pagination])

  // Will unmount
  useEffect(() => () => window.removeEventListener('resize', handleResize))


  const handleResize = () => {
    const header = headerRef.current

    if (header && window.innerWidth > EXTRA_SMALL_SCREEN) {
      const headerClientHeight = header.clientHeight

      const filter = filterRef.current

      const topHeight = headerClientHeight + filter.clientHeight

      let newSideFilterWidth = sideFilterWidth

      filter.style.top = `${headerClientHeight}px`

      if (sideFilterVisible && sideFilterElement)
        newSideFilterWidth = sideFilterElement.clientWidth

      if (topMargin !== topHeight || sideFilterWidth !== newSideFilterWidth) {
        setSideFilterWidth(newSideFilterWidth)

        setTopMargin(topHeight)
      }
    }
  }

  const closeFilter = () => setSideFilterVisible(false)

  const resetFilters = () => setValues(DEFAULT_INITIAL_VALUES)

  const setValues = (values, isSearch = false) => {
    if (isSearch && values) {
      setEmptyFilter(false)
      setFilters({...filters, name: values, page: 1, o: Math.random()})
      return
    }
    if (isSearch && !values) {
      delete filters.name
      setFilters({...filters, page: 1, o: Math.random()})
      setEmptyFilter(true)
      return
    }

    const newFilters = { ...filters, ...values, page: 1, o: Math.random() }

    if (!('status' in values)) {
      delete newFilters.status
    }

    if (newFilters.dtStart === null || newFilters.dtStart === undefined) {
      delete newFilters.dtStart
    }
    if (newFilters.dtEnd === null || newFilters.dtEnd === undefined) {
      delete newFilters.dtEnd
    }

    setFilters(newFilters)
  }

  const removeSelected = (cdParam) => {
    const hasSelected = cdDynamicList.includes(cdParam);
    
    if (hasSelected) {
      const newSelecteds = cdDynamicList.filter(param => param !== cdParam);
      const newSelectedData = selectedItemsData.filter(item => item.cdPricebannerParams !== cdParam);
      setCdDynamicList(newSelecteds);
      setSelectedItemsData(newSelectedData);
    }
  };

  const addSelectedItem = (itemData) => {
    const isAlreadySelected = cdDynamicList.includes(itemData.cdPricebannerParams);
    if (!isAlreadySelected) {
      setCdDynamicList([...cdDynamicList, itemData.cdPricebannerParams]);
      setSelectedItemsData([...selectedItemsData, itemData]);
    }
  };

  const formatDateRange = (dtStart, dtEnd) => {
    const format = (date) => date ? moment(date, ['DD-MM-YYYY', 'YYYY-MM-DD', moment.ISO_8601], true).format('DD/MM/YYYY') : '---';
    return `${format(dtStart)} - ${format(dtEnd)}`;
  };

  const processValidationResult = (result, selectedBranches) => {
    const invalidStores = result?.invalidStores || result?.data || [];
    
    if (!Array.isArray(invalidStores) || invalidStores.length === 0) {
      return false;
    }

    const buildWarningMessage = (validCount, invalidCount) => {
      const successKey = 'price.banner.dynamic.success';
      const integrationKey = validCount === 1 ? 'price.banner.dynamic.warning.integration.singular' : 'price.banner.dynamic.warning.integration.plural';
      const detailsKey = invalidCount === 1 ? 'price.banner.dynamic.warning.details.singular' : 'price.banner.dynamic.warning.details.plural';
      const successMsg = `<div class="price-banner-warning-success-message"><strong class="price-banner-warning-success-title">${translate(successKey)}</strong></div>`;
      const warningMsg = `${successMsg}<div class="price-banner-warning-message">${translate(integrationKey)}</div>`;
      return warningMsg + translate(detailsKey).replace('{details}', '').trim();
    };

    const invalidCount = invalidStores.length;
    const allInvalid = invalidCount === selectedBranches.length;

    if (allInvalid) {
      setDynamicWarningMessage(translate(invalidCount === 1 ? 'price.banner.dynamic.error.total.singular' : 'price.banner.dynamic.error.total.plural'));
      setDynamicWarningType('error');
      setDynamicWarningScrollableList([]);
      setShowDynamicWarningModal(true);
      return true;
    }

    const validCount = selectedBranches.length - invalidCount;
    setDynamicWarningMessage(buildWarningMessage(validCount, invalidCount));
    setDynamicWarningType('warning');
    
    const formattedStores = invalidStores.map(store => {
      const branchId = store.branchId || store.branch_id || '';
      const branchName = store.branchName || store.branch_name || '';
      return `${branchId.padStart(4, '0')} - ${branchName}`;
    });
    
    setDynamicWarningScrollableList(formattedStores);
    setShowDynamicWarningModal(true);
    return true;
  };

  const handleCreate = async (payload) => {
    setLastTriedPayload(payload);
    const selectedBranches = payload.idBranches || [];
    
    try {
      const result = await saveParams(dsToken, payload);
      
      forceCloseRef.current = true;
      setOpenAddModal(false);
      setLastTriedPayload(null);
      
      const processed = processValidationResult(result, selectedBranches);
      if (processed) return;
      
      setSuccessMessage(translate('parameters.success.msg'));
      setOpenSuccessModal(true);
      
    } catch (error) {
      const status = error?.cdStatus;
      forceCloseRef.current = true;
      setOpenAddModal(false);

      if (status === 409) {
        const message = translate('price.banner.error', {
          dsDynamic: payload.dynamic?.dsDynamic || '---',
          dateRange: formatDateRange(payload.dtStart, payload.dtEnd),
          interpolation: { escapeValue: false }
        });

        setErrorDetails(message);
        setOpenWarningModal(true);
        return;
      }

      if (error?.invalidStores || (Array.isArray(error?.data) && error.data.length > 0)) {
        const errorResult = { invalidStores: error.invalidStores || error.data };
        const processed = processValidationResult(errorResult, selectedBranches);
        if (processed) return;
      }

      setErrorDetails(translate('price.banner.error.default'));
      setFailedOperation('CREATE');
      setOpenErrorModal(true);
    }
  }

  const handleModalClose = () => {
    setOpenSuccessModal(false)

    const param = {
      ...DEFAULT_PAGINATION,
      ...filters,
      ...order,
      size: optionSize,
      idBranches: filters.idBranchesCodes ?? filters.idBranches ?? [],
    };

    delete param.idBranchesCodes;

    fetchAll(dsToken, param);
  }

  // ADD MODAL
  const handleAddModalOpenChange = (isOpen) => {
    if (isOpen) {
      forceCloseRef.current = false; 
      setOpenAddModal(true);
      return;
    }

    if (!forceCloseRef.current) {
      setShowConfirmExitModal(true);
      return;
    }

    setOpenAddModal(false);
    setLastTriedPayload(null);
    forceCloseRef.current = false;
  };

  const renderAddModal = () => {
    if(!openAddModal) return
    return (
      <PricebannerAddModal
        title={translate('price.banner.params.new')}
        open={openAddModal}
        onOpenChange={handleAddModalOpenChange}
        onSave={handleCreate}
        initialData={lastTriedPayload}
        translate={translate}
        user={auth.user}
      />
    )
  }

  const renderSuccessModal = () => {
    if (!openSuccessModal) return

    return (
      <SuccessModal 
        fillButton 
        center 
        handleClose={handleModalClose}  
        size='lg' 
        buttonText={translate('ok_button')}
        msg={successMessage || translate('parameters.success.msg')}
        t={translate} 
      />
    )
  }

  // ERROR MODAL
  const handleRetry = () => {
    setOpenErrorModal(false);
    
    if (failedOperation === 'CREATE') {
      forceCloseRef.current = true;
      setOpenAddModal(true);
    } else if (failedOperation === 'UPDATE' && lastTriedPayload?._editData) {
      forceCloseRef.current = true;
      setOpenEditModal({ show: true, selected: lastTriedPayload._editData });
    } else if (failedOperation === 'DELETE' && failedDeleteData) {
      setOpenDeleteModal({ show: true, selected: failedDeleteData });
      setFailedDeleteData(null);
    }
    
    setFailedOperation(null);
  };

  const handleCloseErrorModal = () => {
    setOpenErrorModal(false);
    forceCloseRef.current = true;
    
    if (failedOperation === 'CREATE' || failedOperation === 'UPDATE') {
      if (failedOperation === 'CREATE') {
        setOpenAddModal(false);
      } else {
        setOpenEditModal({ show: false, selected: null });
      }
      setLastTriedPayload(null);
    } else if (failedOperation === 'DELETE') {
      setFailedDeleteData(null);
    }
    
    setFailedOperation(null);
    
    setTimeout(() => {
      forceCloseRef.current = false;
    }, 10);
  };

  const renderErrorModal = () => {
    if (!openErrorModal) return null;

    return (
      <PricebannerErrorModal
        onConfirm={handleRetry}
        onClose={handleCloseErrorModal}
        text={(translate('price.banner.error.generic'))}
        title={translate('price.banner.modal.ops')}
        details={translate('price.banner.error.details')}
        okButton={(translate('newLogin.errorModal.button.label'))}
        translate={translate} 
      />
    )
  }

  // WARNING MODAL
  const handleSeeExisting = () => {
    if (!lastTriedPayload) return;

    setOpenWarningModal(false);

    const parsedStart = normalizeDateToApi(lastTriedPayload.dtStart);
    const parsedEnd = normalizeDateToApi(lastTriedPayload.dtEnd);
    const { dtStart, dtEnd } = normalizeAnnualRange(parsedStart, parsedEnd, lastTriedPayload?.annualRepeat);

    const idBranches = [...new Set(lastTriedPayload.idBranches || [])];
    const cdDynamic = lastTriedPayload.dynamic?.cdDynamic || null;
    const dsCard = lastTriedPayload.dsCard || DEFAULT_INITIAL_VALUES.dsCard;
    const annualRepeat = Boolean(lastTriedPayload?.annualRepeat);

    const filterParams = {
      ...DEFAULT_PAGINATION,
      ...order,
      size: optionSize,
      dsCard,
      ...(cdDynamic && { cdDynamic }),
      ...(dtStart && { dtStart }),
      ...(dtEnd && { dtEnd }),
      ...(annualRepeat && { annualRepeat }),
      ...(idBranches.length > 0 && { idBranches }),
    };

    fetchAll(dsToken, filterParams);
    setPagination(DEFAULT_PAGINATION);

    setLastTriedPayload(null);
    forceCloseRef.current = false;
  };

  const handleCloseWarningModal = () => {
    setOpenWarningModal(false);
    setLastTriedPayload(null);
    forceCloseRef.current = false;
  };

  const handleRetryWarning = () => {
    setOpenWarningModal(false);
    forceCloseRef.current = true;
    setOpenAddModal(true);
  };

  const renderWarningModal = () => {
    if (!openWarningModal) return null;

    return (
      <PricebannerWarningModal
        onNewRegister={handleRetryWarning}
        onSeeExisting={handleSeeExisting}
        onClose={handleCloseWarningModal}
        details={errorDetails}
        isOpen={true}
        translate={translate}
      />
    );
  };

  const renderDynamicWarningModal = () => {
    if (!showDynamicWarningModal) return null;

    return (
      <DetailedWarningModal
        translate={translate}
        message={dynamicWarningMessage}
        messageAsHtml={dynamicWarningMessage}
        onClose={() => {
          setShowDynamicWarningModal(false);
          setDynamicWarningMessage('');
          setDynamicWarningScrollableList(null);
          if (dynamicWarningType === 'warning') {
            forceCloseRef.current = true;
            setOpenAddModal(false);
            setLastTriedPayload(null);
            const param = {
              ...DEFAULT_PAGINATION,
              ...filters,
              ...order,
              size: optionSize,
            };
            fetchAll(dsToken, param);
          }
        }}
        isError={dynamicWarningType === 'error'}
        showButton1={false}
        scrollableList={dynamicWarningScrollableList}
        singleButtonCenter={true}
      />
    );
  };

  // CONFIRM EXIT MODAL
  const handleConfirmExit = () => {
    setShowConfirmExitModal(false);
    forceCloseRef.current = true;

    if (openAddModal) {
      setOpenAddModal(false);
       setLastTriedPayload(null);
    }

    if (openEditModal.show) {
      setOpenEditModal({ show: false, selected: null });
    }

    setTimeout(() => {
    forceCloseRef.current = false;
    }, 10);
  };

  const renderConfirmExitModal = () => {
    if (
    !showConfirmExitModal ||
    openErrorModal ||
    openWarningModal ||
    openSuccessModal
  ) {
    return null;
  }

    return (
      <PricebannerConfirmExitModal
        isOpen={showConfirmExitModal}
        onClose={() => setShowConfirmExitModal(false)}
        onConfirm={handleConfirmExit}
        translate={translate}
      />
    );
  };

  // VIEW MODAL
  const handleOpenEditModalFromView = (param) => {
    setOpenViewModel({ show: false, selected: null }); 
    setOpenEditModal({ show: true, selected: param }); 
  };

  const renderViewModal = () => {
    if (!openViewModel.show) return null

    return (
      <ViewModal
        param={openViewModel.selected}
        closeModal={() => setOpenViewModel({ show: false, selected: null })}
        translate={translate}
        openEditModal={handleOpenEditModalFromView}
      />
    )
  }

  const handleViewModal = (index) => {
    
    setOpenViewModel({show: true, selected: index})
  }

  // EDIT MODAL
  const handleUpdate = async (payload) => {
    const payloadWithId = {
      ...payload,
      cdPricebannerParams: openEditModal.selected.cdPricebannerParams,
    };

    setLastTriedPayload(payload);
    const selectedBranches = payload.idBranches || [];
    
    try {
      const result = await updateParams(dsToken, payloadWithId);
      
      forceCloseRef.current = true;
      setOpenEditModal({ show: false, selected: null });
      setLastTriedPayload(null);
      
      const processed = processValidationResult(result, selectedBranches);
      if (processed) return;
      
      setSuccessMessage(translate('parameters.success.msg.edit'));
      setOpenSuccessModal(true);
      
    } catch (error) {
      const status = error?.cdStatus;
      const editData = openEditModal.selected;
      forceCloseRef.current = true;
      setOpenEditModal({ show: false, selected: null });

      if (status === 409) {
        const message = translate('price.banner.error', {
          dsDynamic: payload.dynamic?.dsDynamic || '---',
          dateRange: formatDateRange(payload.dtStart, payload.dtEnd),
          interpolation: { escapeValue: false }
        });
        setErrorDetails(message);
        setOpenWarningModal(true);
        return;
      }

      if (error?.invalidStores || (Array.isArray(error?.data) && error.data.length > 0)) {
        const errorResult = { invalidStores: error.invalidStores || error.data };
        const processed = processValidationResult(errorResult, selectedBranches);
        if (processed) return;
      }

      setErrorDetails(translate('price.banner.error.default'));
      setFailedOperation('UPDATE');
      setLastTriedPayload({ ...payload, _editData: editData });
      setOpenErrorModal(true);
    }
  };

  const handleEditModalOpenChange = (isOpen) => {
    if (isOpen) {
      forceCloseRef.current = false; 
      return;
    }

    if (!isOpen) {
      if (!forceCloseRef.current) {
        setShowConfirmExitModal(true);
        return;
      }
    }
    setOpenEditModal({ show: isOpen, selected: isOpen ? openEditModal.selected : null });
    if (!isOpen) {
      forceCloseRef.current = false;
    }
  };

  const renderEditModal = () => {
    if (!openEditModal.show) return null;

    return (
      <PricebannerAddModal
        title={translate('price.banner.params.edit')}
        open={openEditModal.show}
        onOpenChange={handleEditModalOpenChange}
        onSave={handleUpdate}
        initialData={openEditModal.selected}
        translate={translate}
        user={auth.user}
      />
    );
  };

  // DELETE MODAL
  const handleOpenDeleteModal = (selectedIds) => {
    const selectedObjects = selectedIds
      .map(id => {
        const storedItem = selectedItemsData.find(item => item.cdPricebannerParams === id);
        if (storedItem) return storedItem;
        
        return list.find(item => item.cdPricebannerParams === id);
      })
      .filter(Boolean); 
    setOpenDeleteModal({ show: true, selected: selectedObjects });
  };

  const handleConfirmDelete = async (id) => {
    if (!id) return;

    const selectedItem = list.find(item => item.cdPricebannerParams === id);
    const deleteData = selectedItem ? [selectedItem] : null;

    const success = await deleteParams(dsToken, [id]);

    if (success) {
      setSuccessMessage(translate('parameters.success.msg.delete.single'));
      setOpenSuccessModal(true);
    } else {
      setFailedOperation('DELETE');
      setFailedDeleteData(deleteData);
      setOpenErrorModal(true);
    }
  };

  const renderDeleteModal = () => {
    if (!openDeleteModal.show) return null;

    const selectedItems = openDeleteModal.selected || [];

    const isSingle = selectedItems.length === 1;
    const dynamicName = isSingle ? selectedItems[0].dynamic?.dsDynamic : null;

    const message = () => {
      if (isSingle) return null; 

      return (
        <div className='delete-multi-dynamics'>
          <p style={{ fontSize: '18px' }}>
            {translate('price.banner.params.delete.multiple.intro', { count: selectedItems.length })}
            <br />
            {translate('price.banner.params.delete.multiple.question')}
          </p>
          <p style={{ fontSize: '16px', marginTop: '1rem', fontWeight: 'bold' }}>
            {translate('price.banner.params.delete.multiple.dynamics')}
          </p>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            {selectedItems.map((item, index) => (
              <li key={index}>{item.dynamic?.dsDynamic}</li>
            ))}
          </ul>
        </div>
      );
    };

    const handleConfirmDeleteMultiple = async (selectedItems) => {
      const ids = selectedItems.map((item) => item.cdPricebannerParams);

      setOpenDeleteModal({ show: false, selected: null });

      const success = await deleteParams(dsToken, ids);

      if (success) {
        const message =
          ids.length === 1
            ? translate('parameters.success.msg.delete.single')
            : translate('parameters.success.msg.delete.plural');

        setSuccessMessage(message);
        setOpenSuccessModal(true);
      } else {
        setFailedOperation('DELETE');
        setFailedDeleteData(selectedItems);
        setOpenErrorModal(true);
      }

      setCdDynamicList([]);
      setSelectedItemsData([]);
    };

    return (
      <ExclusionModalPriceBanner
        isOpen={true}
        useControlledState={true}
        onClose={() => setOpenDeleteModal({ show: false, selected: null })}
        t={translate}
        title={translate("price.banner.params.delete")}
        message={message}
        dynamicName={dynamicName}
        onConfirm={() => handleConfirmDeleteMultiple(selectedItems)} 
        confirmButtonMsg={translate('missionMenu.removeModal.ok')}
        cancelButtonMsg={translate('cancel_button')}
        size="sm"
        renderButton={null}
      />
    );
  };


  const handleOrder = (order,orderDirection) => {
    const param = {
      ...filters,
      ...pagination,
      order,
      orderDirection
    }

    setOrder({order, orderDirection})

    fetchAll(dsToken, param)
  }

  const renderNewPagination = () => {
    const PAGINATION_OPTIONS = [
      { label: '5', value: 5 },
      { label: '10', value: 10 },
      { label: '20', value: 20 },
      { label: '30', value: 30 },
      { label: '40', value: 40 },
    ]

    const countItems = () => {
      if (metadata.page === 1) return 1;
      return ((metadata.page - 1) * metadata.perPage) + 1;
    };


    const DropdownIndicator = props => (
      <components.DropdownIndicator {...props}>
        <DropdownArrow />
      </components.DropdownIndicator>
    )

    if(!(list ?? []).length) return

    return (
      <Row className="new-relatory-row stock-transfer-pagination" >
        <Col className="align-center margin-bottom ">
          <NewPagination
          navClass='pagination new-relatory'
          count={metadata.totalCount}
          current={metadata.page}
           getPage={(page) =>
            setPagination({ ...pagination, size: optionSize, page })
          }
          pages={metadata.pageCount}
          />

          <div  className='datasheet-manager-pagination-size-selector show-pages-new-relatory'>
            <Col className="show-per-page-text" xs={7}>{translate('pagination.size.selector')}</Col>
            <Col xs={4}>
              <SizeSelect
                components={{DropdownIndicator}}
                isSearchable={false}
                styles={colourStyles}
                classNamePrefix='react-select'
                onChange={(option) => {
                  setOptionSize(option.value)
                  setPagination({...pagination, page: 1, size: option.value})
                }}
                options={PAGINATION_OPTIONS}
                value={PAGINATION_OPTIONS.find((i) => i.value === optionSize)}
                menuPlacement='top'
              />
            </Col>
          </div>

          <div style={{float: 'left'}} className='datasheet-manager-pagination-size-selector show-items-new-relatory'>
            <Col >{`
            ${translate('pagination.size.show')}
            ${countItems()} - ${
              metadata.page * optionSize > metadata.totalCount 
              ? metadata.totalCount 
              : metadata.page * optionSize }
            ${translate("pagination.size.of")}
            ${metadata.totalCount}
            ${translate("pagination.size.items")}`}
            </Col>
          </div>
        </Col>
      </Row>
    )
  }
  
  const isDefaultFilter = () => {
    if (!filters) return true; 

    return (
    (filters.idBranches?.length ?? 0) === 0 &&
    (filters.status == null || filters.status === '') &&  
    (filters.dsCard === "Todos" || !filters.dsCard)
  );
  };

  useEffect(() => {
    if(cdDynamicList.length > 0 && !actionMode) {
      setActionMode(true)
    }

  }, [cdDynamicList])

  const inActionMode = cdDynamicList.length > 0

  const hasData = (list ?? []).length > 0;
  const defaultFilter = isDefaultFilter();

  return (
    <div className='stock-adjustment pricebanner-params'>
      <div ref={headerRef} className='stock-adjustment-header'>
        <ContentHeader>{translate('price.banner.params')}</ContentHeader>
      </div>

      <div ref={filterRef} 
        className={`padding-bottom header-mission-block ${cdDynamicList.length === 0 ? 'pricebanner-margin-top' : ''}`}
      >
        <DynamicsSelector
          dynamicsSelected={cdDynamicList}
          cdDynamicList={cdDynamicList.length}
          handleSideFilterMenuCollapseChange={setSideFilterVisible}
          setCdDynamicList={setCdDynamicList}
          setRemoveModal={handleOpenDeleteModal}
          sideFilterVisible={sideFilterVisible}
          translate={translate}
        />
      </div>

      {!inActionMode && (
        <div ref={filterRef} className='spacing-end'>
          <button 
            style={{ marginRight: '24px', background: "#41A017", borderRadius: '8px', height:'44px', color: "#fff"}} 
            className='btn filter-mission-block' onClick={() => setOpenAddModal(true)}
          >
            {(translate('price.banner.new'))}
          </button>

          <button style={{ marginRight: '27px' }} className='btn filter-mission-block' onClick={() => setSideFilterVisible(true)}>
            <FilterSVG newDesign={false} className="common-download"/>
            <span>{translate('commonReport.filters')}</span>
          </button>
        </div>
      )}

      <div
        style={{ margin: '0 !important' }}
        ref={tableRef}
        className='stock-adjustment-table new'
      >

          <div style={{boxShadow: (list ?? []).length < 1 && 'none'}} className='outer-table stock-transfer-outer-table'>
            <div className='flex'>
              <SideFilterParams
                user={auth.user}
                resetFilters={resetFilters}
                closeFilters={closeFilter}
                handleSideFilterElementChange={setSideFilterElement}
                initialValues={DEFAULT_INITIAL_VALUES}
                sideFilterVisible={sideFilterVisible}
                submit={setValues}
                translate={translate}
                initialFilters={filters}
              />
              {hasData ? (
                <TableParams
                  emptyFilter={emptyFilter}
                  removeSelected={removeSelected}
                  addSelectedItem={addSelectedItem}
                  cdDynamicList={cdDynamicList}
                  handleOrder={handleOrder}
                  handleResize={handleResize}
                  handleConfirmDelete={handleConfirmDelete}
                  openModal={(index) => handleViewModal(index)}
                  editModal={(record) => setOpenEditModal({ show: true, selected: record })}
                  records={displayList}
                  setCdDynamicList={setCdDynamicList}
                  setSelectedItemsData={setSelectedItemsData}
                  translate={translate}
                  currentOrder={order}
                />
              ) : defaultFilter ? ( 
                <div
                  style={{ width: '100%', height: '500px', margin: '0px' }}
                  className='relatory-no-data pictogram-empty no-register'
                >
                  <p className="no-register-title">{translate('price.banner.params.no.data')}</p>
                  <p className="no-register-subtitle">{translate('price.banner.params.start.registration')}</p>
                </div>
              ) : (
                <div
                  style={{ width: '100%', height: '500px', margin: '0px' }}
                  className='relatory-no-data pictogram-empty'
                >
                  <p style={{ fontSize: '24px' }}>{translate('no.results')}</p>
                  <p className='no-result-filter'>{translate('no.results.please')}</p>
                </div>
              )}
            </div>
           {renderNewPagination()}
          </div>

      </div>
      {renderAddModal()}
      {renderSuccessModal()}
      {renderErrorModal()}
      {renderWarningModal()}
      {renderDynamicWarningModal()}
      {renderConfirmExitModal()}
      {renderViewModal()}
      {renderEditModal()}
      {renderDeleteModal()}

    </div>
  )
}

PriceBannerParamsContainer.propTypes = {
  auth: PropTypes.object.isRequired,
  count: PropTypes.number.isRequired,
  current: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  fetchAll: PropTypes.func.isRequired,
  updateParams: PropTypes.func.isRequired,
  deleteParams: PropTypes.func.isRequired,
  saveParams:PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  list: PropTypes.array,
  metadata: PropTypes.object

}

/* istanbul ignore next */
const mapStateToProps = (state) => ({
    list: state.pricebannerParamsReducer?.list ?? [],
    metadata: state.pricebannerParamsReducer?.metadata ?? {},
    error: state.pricebannerParamsReducer?.error ?? null,
    dataSave: state.pricebannerParamsReducer?.dataSave ?? null,
    errorSave: state.pricebannerParamsReducer?.errorSave ?? null,
  });


/* istanbul ignore next */
const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
      fetchAll: pricebannerParamsActions.fetchAll,
      saveParams: pricebannerParamsActions.saveParams,
      updateParams: pricebannerParamsActions.updateParams,
      deleteParams: pricebannerParamsActions.deleteParams,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  translate(null, { wait: true, translateFuncName: 'translate' })(
    PriceBannerParamsContainer
  )
)

export { PriceBannerParamsContainer }
